export default __webpack_public_path__ + "static/media/icon-cacamba.cb0af0a0.svg";